export function clampPercent(value) {
  return Math.min(100, Math.max(0, value));
}
